"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleSuccessLoadMenu = exports.handleLoadMenuFunc = exports.handleCopi = exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("webmotors-react-pj/utils");
var _config = require("webmotors-react-pj/config");
var _store = _interopRequireDefault(require("webmotors-react-pj/frame/modal/store"));
var _menu = _interopRequireDefault(require("webmotors-react-pj/frame/modal/menu"));
var _items = _interopRequireDefault(require("webmotors-react-pj/frame/menu/items"));
var _style = require("webmotors-react-pj/frame/menu/list/style");
var _translate = _interopRequireDefault(require("webmotors-react-pj/translate"));
var _context = _interopRequireDefault(require("../context"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const handleCopi = () => {
  const copi = document.getElementById('drz_btn_open_updated');
  if (copi) {
    copi.click();
  }
};
exports.handleCopi = handleCopi;
const handleSuccessLoadMenu = e => {
  const {
    success,
    dataMenu,
    setMenu,
    menuConfig
  } = e;
  if (success) {
    let menuExpTime = new Date();
    menuExpTime.setDate(menuExpTime.getDate() + 15);
    localStorage.setItem("cockpitMenu", JSON.stringify(dataMenu));
    localStorage.setItem("cockpitMenuExp", JSON.stringify(menuExpTime));
    setMenu(dataMenu);
  } else {
    setMenu(menuConfig);
  }
};
exports.handleSuccessLoadMenu = handleSuccessLoadMenu;
const handleLoadMenuFunc = function (setMenu) {
  let MenuConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _translate.default.menu.default;
  let handleSuccessLoadMenuFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : handleSuccessLoadMenu;
  return (0, _utils.Ajax)({
    url: "".concat(_config.ApiMenu, "/menu/"),
    method: 'GET'
  }).then(e => {
    const {
      success,
      data: dataMenu
    } = e;
    const sucessObject = {
      success: success,
      dataMenu: dataMenu,
      setMenu: setMenu,
      menuConfig: MenuConfig
    };
    handleSuccessLoadMenuFunc(sucessObject);
  }).catch(() => {
    setMenu(MenuConfig);
  });
};
exports.handleLoadMenuFunc = handleLoadMenuFunc;
var _default = _ref => {
  let {
    handleLoadMenu = handleLoadMenuFunc,
    menuData = []
  } = _ref;
  const {
    get: {
      pinnedMenu,
      showPin
    }
  } = (0, _react.useContext)(_context.default);
  const {
    default: MenuConfig
  } = _translate.default.menu;
  const [menu, setMenu] = (0, _react.useState)(menuData);
  const [menuProducts, setMenuProducts] = (0, _react.useState)([]);
  const [menuInternal, setMenuInternal] = (0, _react.useState)([]);
  const [openModalStore, setOpenModalStore] = (0, _react.useState)(false);
  const [openModalMenu, setOpenModalMenu] = (0, _react.useState)(false);
  const [redirect, setRedirect] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (menu) {
      setMenuProducts(menu.filter(item => item.order === 1));
      setMenuInternal(menu.filter(item => item.order === 2));
    }
  }, [menu]);
  (0, _react.useEffect)(() => {
    const cockpitMenuCached = window.localStorage.getItem("cockpitMenu");
    const cockpitMenuExp = window.localStorage.getItem("cockpitMenuExp");
    if (!cockpitMenuCached) {
      handleLoadMenu(setMenu);
    } else if (cockpitMenuExp && new Date(JSON.parse(cockpitMenuExp)) <= new Date()) {
      handleLoadMenu(setMenu);
    } else {
      const cockpitMenuCachedObj = JSON.parse(cockpitMenuCached);
      setMenu(cockpitMenuCachedObj);
    }
  }, []);
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_style.StyleList, null, menuProducts.map(item => _react.default.createElement(_items.default, {
    key: item.key,
    onModal: () => setOpenModalMenu(item),
    onModalStore: () => setOpenModalStore(true),
    onRedirect: url => setRedirect(url),
    tracking: item.tracking
  }, item))), _react.default.createElement(_style.StyleList, null, menuInternal.map(item => _react.default.createElement(_items.default, {
    key: item.key,
    onModal: () => setOpenModalMenu(item),
    onModalStore: () => setOpenModalStore(true),
    onRedirect: url => setRedirect(url),
    tracking: item.tracking
  }, item)), _react.default.createElement(_style.StyleCopi, {
    onClick: () => handleCopi()
  }, _react.default.createElement(_style.StyleCopiImg, {
    pinnedMenu: pinnedMenu,
    showPin: showPin
  }), _react.default.createElement(_style.StyleCopiText, {
    pinnedMenu: pinnedMenu,
    showPin: showPin
  }, "Posso ajudar?"))), openModalStore && _react.default.createElement(_store.default, {
    onClose: () => setOpenModalStore(false),
    onRedirect: redirect
  }), openModalMenu && _react.default.createElement(_menu.default, {
    params: openModalMenu,
    onClose: () => setOpenModalMenu(false)
  }));
};
exports.default = _default;